import React from "react";

export default function ProjectIcon({ className, size = 14, strokeWidth = 1.401, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="2.1 2.1 12.6 12.6"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M2.803 5.606h11.21v7.007c0 .774-.627 1.401-1.4 1.401H4.203a1.4 1.4 0 0 1-1.401-1.401zM5.606 2.803h5.605l2.803 2.803H2.803zM5.605 8.408h2.803" />
    </svg>
  );
}
